import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router"
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as confetti from 'canvas-confetti';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CoreEnvironment } from '@angular/core/src/render3/jit/compiler_facade_interface';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent
{constructor(public ngxSmartModalService: NgxSmartModalService, public http: HttpClient, private router: Router) {this.ping(), this.account()}
languageList = [    { code: 'ar', label: 'Arabic' },    { code: 'fr', label: 'French' }  ];
notifications: any = [];
notification: any = [];
searchString: any;
siteID = environment.siteID;
confettiGunLoaded: boolean = true;
confettiGunReady: boolean = true;
menuclosed = true;
search: boolean = false;
notificationLength = 0;
notificationRead = 1;
 totalEntries:number;
notificationID = 1;
isWoohoo: boolean = environment['isWooHoo'];
qualityName= '';
quality: any;
profileID = '';
public messageClasses = { 
  "messageSeen": this.notificationRead,
  "messageunSeen": !this.notificationRead
}
messageIndex = 3;
playlists: any = [];
contents: any = [];
profileData: any = [];
terms = environment['terms'];
currency:string = '';
timezone:string = '';
celebrationMessages: any = [];
public show:boolean = false;
  public buttonName:any = 'Hide';
type= 'site';
// public instantCelebrate() { 
//   this.celebrationMessages = [];
//   this.confettiGunReady = true;
// this.confettiGunLoaded = true;
//   const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
//   let body = new HttpParams();
// this.http.get('https://api-staging.videyo.tv/endpoint/getNotifications?siteID='+this.siteID,{
//   headers:myheader
// })
// .subscribe(
//   data => {
//     this.notifications = data['notification'];
//     this.celebrationMessages =  this.notifications.filter(function(message) {
//       return message.type == "CELEBRATION";
//     });
//     this.celebrationMessages =  this.notifications.filter(function(message) {
//       return message.notificationNoted == false;
//     });
    
// console.log('celebration message')
// console.log(this.celebrationMessages);
//     this.notificationRead = data['notification.notificationNoted']
//     this.notificationID = data['notification.id']
//     //this.notificationLength = this.notification.length;
//     if (this.notification != null){
//       this.notification.reverse().forEach(note => {
//         if (!note.notificationNoted && note.type != 'CELEBRATION') {
//           this.notificationLength++
//         }
//       });
//     }
//   },
//   error => {
//     console.log('1st celebration fail')
//   });
//   this.notifications = [];
// }
public ping() {
    this.celebrationMessages = [];
    this.confettiGunReady = true;
  this.confettiGunLoaded = true;
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  this.http.get('https://api-staging.videyo.tv/endpoint/getNotifications?siteID='+this.siteID,{
    headers:myheader
  })
  .subscribe(
    data => {
      this.notifications = data['notification'];
      this.celebrationMessages =  this.notifications.filter(function(message) {
        return message.type == "CELEBRATION";
      });
      this.celebrationMessages =  this.notifications.filter(function(message) {
        return message.notificationNoted == false;
      });
      
console.log('celebration message')
console.log(this.celebrationMessages);
      this.notificationRead = data['notification.notificationNoted']
      this.notificationID = data['notification.id']
      //this.notificationLength = this.notification.length;
      if (this.notification != null){
        this.notification.reverse().forEach(note => {
          if (!note.notificationNoted && note.type != 'CELEBRATION') {
            this.notificationLength++
          }
        });
      }
    },
    error => {
     console.log('notification error')
    });
    this.notifications = [];

  }

public account() {
  const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  this.http.get('https://api-staging.videyo.tv/endpoint/getCurrentProfile',{
    headers:myheader
  })
  .subscribe(
    data => {
       this.profileData = data;
       this.profileID = this.profileData['id'];
       console.log(this.profileData);
       this.currency = this.profileData.currency.name;
       this.timezone = this.profileData.timezone.ID;
       this.quality = this.profileData.quality.name;
       if (this.quality == 'MOBILE') { 
        this.qualityName = '240p';
       }
       if (this.quality == 'TABLET') { 
        this.qualityName = '360p';
       }
       if (this.quality == 'DESKTOP') { 
        this.qualityName = '480p';
       }
       if (this.quality == 'INTRINSIC') { 
        this.qualityName = '720p';
       }
       if (this.quality == 'ORIGINAL') { 
        this.qualityName = '1080p';
       }
           },
           error => {
            if (error.status >= 400 && error.status < 500) { 
              this.ngxSmartModalService.create('myModal1', '').open();
            }
         else if (error.status >= 500) { 
location.reload();
        }
            console.log('ERROR:');
            console.log(error);
          }
    );
}
onMobile(){
  this.quality = 'MOBILE';
  this.changeQuality();
  this.qualityName = '240p';
  setTimeout(window.location.reload.bind(window.location), 500);
}
onTablet(){
  this.quality = 'TABLET';
  this.changeQuality();
  this.qualityName = '360p';
  setTimeout(window.location.reload.bind(window.location), 500);
}
onDesktop(){
  this.quality = 'DESKTOP';
  this.changeQuality();
  this.qualityName = '480p';
  setTimeout(window.location.reload.bind(window.location), 500);
}
onIntrinsic(){
  this.quality = 'INTRINSIC';
  this.changeQuality();
  this.qualityName = '720p';
  setTimeout(window.location.reload.bind(window.location), 1000);
}
onOriginal(){
  this.quality = 'ORIGINAL';
  this.changeQuality();
  this.qualityName = '1080p';
  setTimeout(window.location.reload.bind(window.location), 1000);
}
public changeQuality() {
  this.quality;
  const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  this.http.get('https://api-staging.videyo.tv/endpoint/saveProfileUpdate?quality='+this.quality,{
    headers:myheader
  })
  .subscribe(
    data => {
    },
    error => {
      if (error.status >= 400 && error.status < 500) { 
        this.ngxSmartModalService.create('myModal1', '').open();
      }
      else if (error.status >= 500) { 
        this.ngxSmartModalService.create('myModal2', '').open();
        
      }
      console.log('ERROR:');
      console.log(error);
    }
    );
}
// public getWoohooEntries() { 
//   this.http.get('https://staging.videyo.tv/endpoint/getCurrentEntries?siteID='+this.siteID, {
//    })
//    .subscribe(
//      data => {
//        console.log('entries');
//        console.log(data);
//        this.totalEntries = data['totalEntriesToday'];
//      },
//      error => {
//       if (error.status >= 400 && error.status < 500) { 
//         this.ngxSmartModalService.create('myModal1', '').open();
//       }
//       else if (error.status >= 500) { 
//         this.ngxSmartModalService.create('myModal2', '').open();
        
//       }
//       console.log('ERROR:');
//       console.log(error);
//     }
//    );
   
//  }
public confettiGun() {
  this.confettiGunLoaded = false;
  var myCanvas = document.getElementById('CustomCanvas');
  var myConfetti = confetti.create(myCanvas, { resize: true });
  var end = Date.now() + (15 * 200);
  var interval = setInterval(function() {
  if (Date.now() > end) {
    this.celebrate = true;
      return clearInterval(interval);
  }
  else { 
    this.celebrate = false;
  }

  myConfetti({
      startVelocity: 25,
      spread: 560,
      particleCount: 200,
      ticks: 60,
      shapes: ['square'],
      origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
      }
  });
}, 200);

setTimeout(() => {
  this.endConfettiGun() 
}, 3000);
  setTimeout(() => {
    document.getElementById('CustomCanvas').appendChild(myCanvas);
  }, 10000);
 
}
endConfettiGun() {
this.clearNotifications(); this.confettiGunReady = false; this.confettiGunLoaded = false;
}

  
public clearNotification(idTemp) {
  const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  this.http.get('https://api-staging.videyo.tv/endpoint/viewNotification?siteID='+this.siteID+'&notificationID='+idTemp,{
  })
  .subscribe(
    data => {
    },
    error => {
      if (error.status >= 400 && error.status < 500) { 
        this.ngxSmartModalService.create('myModal1', '').open();
      }
      else if (error.status >= 500) { 
        this.ngxSmartModalService.create('myModal2', '').open();
        
      }
      console.log('ERROR:');
      console.log(error);
    });
}
public clearNotifications() {
  const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  this.http.get('https://api-staging.videyo.tv/endpoint/clearNotifications?siteID='+this.siteID,{
  })
  .subscribe(
    data => {
    },
    error => {
      if (error.status >= 400 && error.status < 500) { 
        this.ngxSmartModalService.create('myModal1', '').open();
      }
      else if (error.status >= 500) { 
        this.ngxSmartModalService.create('myModal2', '').open();
        
      }
      console.log('ERROR:');
      console.log(error);
    }
);
}

public toggle() {
  this.show = !this.show;
  if(this.show)  {
    this.buttonName = "Hide";
  }
  else {
    this.buttonName = "Show";
}
}

public toggleMenu() {
this.menuclosed = !this.menuclosed;
}
onSiteSearchKeyUp(event:any){
  this.searchString = event.target.value;
}
siteSearch(){
  this.router.navigate(['/search/'+this.searchString]);
}

 
}